(function () {
  angular
    .module('specsguardApp')
    .controller('sgHelpController', sgHelpController);

  sgHelpController.$inject = ['$mdDialog', 'Help'];

  function sgHelpController ($mdDialog, Help) {
    const vm = this;

    vm.helpPosition = angular.isUndefined(vm.position) ? 'left' : vm.position;
  
    Help.getHelp().then(()=>{
      vm.helpContent = Help.getHelpText(vm.key);
    });

    vm.help = (ev) => {
      $mdDialog.show({
        preserveScope: true,
        multiple: true,
        controllerAs: 'dialogCtrl',
        controller: function () {
          const dc = this;
          dc.close = function () {
            $mdDialog.hide();
          };
          dc.header = vm.helpContent.h;
          dc.body = vm.helpContent.b;
        },
        clickOutsideToClose: true,
        targetEvent: ev,
        template:
          `<md-dialog>
              <md-toolbar>
                <div class="md-toolbar-tools">
                  <md-icon style="margin-right:10px">help</md-icon>
                  <h2 ng-bind-html="dialogCtrl.header"></h2>
                  <span flex></span>
                  <md-button class="md-icon-button" ng-click="dialogCtrl.close()">
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </md-toolbar>
              <md-dialog-content>
                <div class="md-dialog-content" ng-bind-html="dialogCtrl.body"></div>
              </md-dialog-content>
            </md-dialog>`
      });
    };
  }
})();
